import type { Todo } from '../../../types';
import { TodosWidgetList } from '../todos-widget-list';

type P = {
  fetchNextPage: () => unknown;
  hasMoreData?: boolean;
  isFetching: boolean;
  items: Todo[];
};

const FeaturedTodoList = ({ items, ...rest }: P) => {
  const hasMultipleTodos = items.length > 1;

  return (
    <TodosWidgetList
      items={items}
      type="featured"
      {...rest}
      loadingColProps={{ className: 'todos-widget-list-featured__loading', span: 4 }}
      rowProps={{
        className: 'todos-widget-list-featured',
      }}
      todoColProps={{
        span: hasMultipleTodos ? 22 : 24,
      }}
    />
  );
};

export default FeaturedTodoList;
